<script setup>
// §8.3 ProseLink — a link inside running prose. ALWAYS underlined (D6/§7).
defineProps({
  href: { type: String, default: '#' },
})
</script>

<template>
  <a :href="href" class="l-prose-link"><slot /></a>
</template>

<style scoped>
.l-prose-link {
  color: var(--interactive-text);
  text-decoration: underline;
  text-underline-offset: 2px;
  font-weight: 500;
}
.l-prose-link:hover {
  color: var(--interactive-hover);
}
</style>
